export default "__VITE_ASSET__D9ukiug6__"